import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBookmarkFill = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 24 24",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M4 5C4 3.34315 5.34315 2 7 2H17C18.6569 2 20 3.34315 20 5V21.0284C20 22.2485 18.6209 22.9581 17.6281 22.249L12 18.2289L6.37186 22.249C5.37906 22.9581 4 22.2485 4 21.0284V5Z" })
});
export default SvgBookmarkFill;
